export default "__VITE_ASSET__ccbf77f2__"